module.exports = __webpack_public_path__ + "static/media/wmg-logo.c5968da2.svg";